var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1836 11.836L13.1274 2.78443L12.5204 2.1774C12.382 2.04 12.195 1.96289 12 1.96289C11.8051 1.96289 11.618 2.04 11.4797 2.1774L1.81645 11.836C1.67473 11.9772 1.56272 12.1453 1.48705 12.3305C1.41137 12.5156 1.37355 12.7141 1.37583 12.9141C1.3852 13.7391 2.07192 14.3977 2.89692 14.3977H3.89302V22.0313H20.1071V14.3977H21.1243C21.525 14.3977 21.9024 14.2407 22.186 13.9571C22.3256 13.8179 22.4363 13.6524 22.5115 13.4701C22.5867 13.2879 22.6251 13.0925 22.6243 12.8954C22.6243 12.4969 22.4672 12.1196 22.1836 11.836ZM13.3125 20.3438H10.6875V15.5626H13.3125V20.3438ZM18.4196 12.7102V20.3438H14.8125V15.0001C14.8125 14.4821 14.393 14.0626 13.875 14.0626H10.125C9.60708 14.0626 9.18755 14.4821 9.18755 15.0001V20.3438H5.58052V12.7102H3.33052L12.0024 4.04537L12.5438 4.58678L20.6719 12.7102H18.4196Z",
    fill: "#FF7A00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home-active.b4a9ff4ba2851c9853ce6c77872cd8df.svg";
export { ForwardRef as ReactComponent };